module.exports = __webpack_public_path__ + "static/media/bbet.3f7a13e8.svg";